import { OdataFieldBasicOperator } from './OdataFieldBasicOperator';
import { IOdataField } from '../../IOdataField';

export class OdataFieldToUpper extends OdataFieldBasicOperator {
  constructor(field: IOdataField) {
    super(field, 'toupper');
  }
}
